namespace Cfnc {
    "use strict";

    interface IInviteThirdPartyModalScope extends ng.IScope {
        close: () => void;
        send: () => void;
        thirdPartyEmail: string;
        firstName: string;
        lastName: string;
        crmId: number;
    }

    interface IInviteThirdPartyModal {

    }



    class InviteThirdPartyModal implements IInviteThirdPartyModal {
        static $inject: Array<string> = ["$uibModalInstance", "common", "$scope", "$timeout", "data", "Restangular"];
        static controllerId: string = "InviteThirdPartyModal";
        private log;
        constructor(private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance, private common: ICommonFactory, private $scope: IInviteThirdPartyModalScope, private $timeout: ng.ITimeoutService,
            private data: any,
            private Restangular: Restangular.IService) {
            this.log = common.logger.getLogFn(InviteThirdPartyModal.controllerId);
            $scope.close = () => this.close();
            $scope.send = () => this.send();
        }

        close() {
            this.$uibModalInstance.dismiss();
        }

        send() {
            var self = this;
            var params = {
                thirdPartyEmail: this.$scope.thirdPartyEmail,
                firstName: this.$scope.firstName,
                lastName: this.$scope.lastName,
                crmId: this.common.authentication.user.primaryConnection
            }
            this.Restangular.one("application").one(this.data.userApplicationId).one(this.data.taskId).one("thirdparty").get(params).then(
                (response) => {
                    this.$timeout(() => { this.$uibModalInstance.close(true); }, 2000);

                },
                (reason) => {
                    console.log(reason);
                    this.$uibModalInstance.close(true);
                });

        }


    }

    angular.module("app").controller(InviteThirdPartyModal.controllerId, InviteThirdPartyModal);
}  